<template>
    <b-table :id="idName" :class="className" :items="dataList" v-bind="$attrs" show-empty>
        <template #empty>
            <h4 class="text-center">{{ noDataMessage }}</h4>
        </template>
        <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
            <slot :name="name" v-bind="data"></slot>
        </template>
    </b-table>
</template>
<style scoped>
.table {
    font-size: 15px;
}
.table-title {
    font-weight: 700;
    font-size: 13px;
}
</style>
<script>
import DataSource from '@/models/DataSource/DataSource';

export default {
    props: {
        id: {
            default: "app-table-viewer",
            type: String,
        },
        className: {
            default: "",
            type: String,
        },
        idName: {
            default: "",
            type: String,
        }, 
        dataSourceId: {
            default: "",
            type: [Number, String],
        },
        data : 
        {
            default: function() {return [];},
            type: Array,
        },
        noDataMessage : {
            default: "No Data",
            type: String,
        }
    },
    components: {
        
    },
    data() {
        return {
            items : [],
        };
    },
    mounted() {
        if (this.dataSourceId != null && this.dataSourceId != "" && this.dataSourceId != undefined) {
            this.getDataSource();
        }
    },
    computed: {
        dataList() {
            if (this.data != null && this.data.length > 0) {
                return this.data;
            }

            return this.items;
        }
    },
    methods: {
        getDataSource() {
            this.isBusy = true;
			DataSource.getData(this, this.dataSourceId)
            .then(result => { 
                if (Array.isArray(result)) {
                    if (result.length > 0) {
                        this.items = result;
                    }
                }
                this.model = result; 
                this.isBusy = false;
            })
            .catch(error => { 
                this.isBusy = false; 
            });
        }
    },
    watch: {
    }
}
</script>